module.exports = __webpack_public_path__ + "static/media/pathcursor.bc59c8d8.svg";